import { Toast } from '@heroui/react';
import { LearningLanguageProvider, type CurrentUser } from '@/entities/user';
import { i18next } from '@/shared/lib/i18n';
import { toastQueue } from '@/shared/lib/toast';
import { ErrorBoundary } from './providers/ErrorBoundary';
import { AppRouter } from './router/AppRouter';

/**
 * Догадка о языке интерфейса из bootstrap() (Telegram language_code)
 * уточняется авторитетным значением с бэкенда, как только профиль загрузился.
 * Здесь, а не в `RootRedirect` (`AppRouter`): та страница рендерится только на
 * маршруте `/`, а прямой заход/релоад на подстраницу (`/settings`,
 * `/mistakes`, ...) минует её — язык интерфейса застревал бы на
 * Telegram-догадке, даже если пользователь сохранил другой на бэке. Профиль
 * грузит `LearningLanguageProvider` — ему он нужен тем же первым запросом.
 */
function syncLocaleWithBackend(user: CurrentUser): void {
  void i18next.changeLanguage(user.locale);
}

export function App() {
  return (
    <ErrorBoundary>
      {/* Полоса системного выреза (`--status-bar-top`) — выше самой шапки
          (`PageHeader`, `top: var(--status-bar-top)`), поэтому её фон не
          закрывает. Один блок на всё приложение, а не в каждом каркасе
          страницы (`PageLayout`, `SessionShell`, ...) — так гарантированно
          закрыт вообще любой экран, а не только те, что я успел поправить
          спейсером под конкретный контент. */}
      <div
        aria-hidden="true"
        className="fixed inset-x-0 top-0 z-40 h-[var(--status-bar-top)] bg-[var(--color-bg)]"
      />
      <LearningLanguageProvider onUserLoaded={syncLocaleWithBackend}>
        <AppRouter />
      </LearningLanguageProvider>
      {/* Один на всё приложение — `showToast(...)` из любого места пишет в
          `toastQueue`, эта очередь просто её рисует. Не дефолтный `toast()` из
          HeroUI и не его `<Toast.Provider />` без `queue` — см. `shared/lib/toast`. */}
      <Toast.Provider queue={toastQueue} />
    </ErrorBoundary>
  );
}
